/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetFeeConfigsOptions, GetFeeConfigsResponses } from '../types/GetFeeConfigs'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. Returns the configured trading fee rate for each fee tier. The rate is applied to the traded USD notional of a user's fills when the daily settlement run bills them.
 * @summary Get the trading fee configuration of every tenant and tier.
 * {@link /v1/fees/config}
 */
export function getFeeConfigs<ThrowOnError extends boolean = true>(
  options: Options<GetFeeConfigsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetFeeConfigsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/fees/config',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetFeeConfigsResponses, ThrowOnError>>,
  )
}
